export class PlaceDetailsGas {

  id: number;

  operatorName: string;
  code: string;
  placeType: string;

  isProsumer: boolean;

  conventionParties: string[];
  suppliers: string[];

  debit: number;
  pressure: number;
  maximumPressure: number;
  minimumPressure: number;
  minimumTechnicalPressure: number;
  reservedCapacity: number;

  smartMeter: boolean;

  counterIndexReadDate: string;
  counterIndexInterval: number;
  date: string;
  counterIndexDesc: string;
  counterSeries: string;
  counterIndexValue: string;
  number: string;
  consumptionCategory: string;
  technicalDataStatus: string;
  counterType: string;
  networkType: string;
  operatingMode: string;

  conventionType: string;
  conventionNumber: string;
  conventionDate: string;
  conventionPresent: boolean;

  clientIdentificationNumber: string;
  clientName: string;
  contractNumber: string;
  validFrom: string;
  validTo: string;
  contractType: string;


  streetNumber: string;
  streetName: string;
  postalCode: string;
  block: string;
  apartment: string;
  floor: string;
  county: number;
  city: number;
  countyName: string;
  cityName: string;

  accessAgreement: boolean;
  accessAgreementNumber: string;
  accessAgreementDate: string;

  connectionNotice: boolean;
  connectionNoticeNumber: string;
  connectionNoticeDate: string;


}
